import { Delete } from "@mui/icons-material";
import { Button, IconButton, Stack } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import {
	Contact,
	Department,
	useGetAllMembersOfDepartmentLazyQuery,
	useLeavesDepartmentMutation,
} from "@repo/server-api";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";

import DialogEmployee from "../dialogs/DialogEmployee";

const DetailPanelContentDepartments = ({
	row: rowProp,
	contactId,
}: {
	row: Department | null;
	contactId?: string;
}) => {
	const { t } = useTranslation();

	const [getMembers] = useGetAllMembersOfDepartmentLazyQuery({
		fetchPolicy: "no-cache",
		onCompleted(data) {
			if (data && data.allMembersOfDepartment?.nodes) {
				setMembers(data.allMembersOfDepartment.nodes as Contact[]);
			}
		},
	});
	const [members, setMembers] = useState<Contact[]>([]);

	const [openAddMember, setOpenAddMember] = useState(false);
	const [departmentId, setDepartmentId] = useState<string>("");

	useEffect(() => {
		if (rowProp?.id) {
			getMembers({
				variables: {
					first: 100,
					after: null,
					departmentId: rowProp.id.toString(),
				},
			});
		}
		 
	}, [rowProp?.id]);

	const [leavesDepartment] = useLeavesDepartmentMutation({
		onCompleted(data) {
			if (data && data.leavesDepartment) {
				if (data.leavesDepartment.boolean) {
					getMembers({
						variables: {
							first: 100,
							after: null,
							departmentId: rowProp?.id.toString() || "",
						},
					});
				}
			}
		},
	});

	return (
		<Stack sx={{ height: "100%", boxSizing: "border-box" }} direction="column">
			<DialogEmployee
				open={openAddMember}
				setOpen={setOpenAddMember}
				departmantId={departmentId}
				contactId={contactId ?? ""}
				refreshData={() => {
					getMembers({
						variables: {
							first: 100,
							after: null,
							departmentId: rowProp?.id.toString() || "",
						},
					});
				}}
			/>
			{members.length ? (
				<DataGridPremium
					slots={{
						columnHeaders: () => null,
					}}
					density="compact"
					columns={[
						{
							field: "name",
							headerName: t("name"),
							width: 200,
							flex: 1,
							align: "center",
							headerAlign: "center",
							renderCell: (params: GridRenderCellParams) => {
								return (
									<div
										style={{
											justifyContent: "center",
											alignItems: "center",
											display: "flex",
										}}
									>
										{params.row.displayName}
									</div>
								);
							},
						},
						{
							field: "actions",
							headerName: t("actions"),
							sortable: false,
							disableColumnMenu: true,
							width: 100,
							align: "center",
							headerAlign: "center",
							renderCell: (params: GridRenderCellParams) => {
								const handleDelete = (id: string) => {
									if (id) {
										leavesDepartment({
											variables: {
												contactId: id,
											},
										});
									}
								};

								return (
									<div
										style={{
											justifyContent: "center",
											alignItems: "center",
											display: "flex",
										}}
									>
										<IconButton
											onClick={() => {
												handleDelete(params.row.id);
											}}
											size="small"
										>
											<Delete />
										</IconButton>
									</div>
								);
							},
						},
					]}
					rows={members}
					sx={{ flex: 1 }}
					hideFooter
				/>
			) : (
				""
			)}
			<Button
				variant="outlined"
				sx={{ margin: 2 }}
				onClick={() => {
					setDepartmentId(rowProp?.id.toString() || "");
					setOpenAddMember(true);
				}}
			>
				{t("freelancer.create")}
			</Button>
		</Stack>
	);
};

export default DetailPanelContentDepartments;
